export default "__VITE_ASSET__71aed58e__"